<template>
  <div class="cell-button-box">
    <van-button size="small" type="info" class="footer-button" @click="CheckDetail()">
      审核进度
    </van-button>
    <!-- 特别声明，因为当前按钮为嵌套按钮，这里必须加上 append-to-body="true",不然遮罩会在内容上方 ,-->
    <van-dialog v-model="dialogVisible" title="审核进度">
      <van-cell v-if="tableData.length == 0" title="暂无审核信息" />
      <van-cell-group inset>
        <van-cell v-for="(item, index) in tableData" :key="index" :title="item.CheckUser" :label="item.CheckInfo" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
  export default {
    name: 'OAButton',
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        //审核意见获取列表
        searchUrl:this.$utils.Url.s004 + "/S004/bq010/getcheckresult"
      }
    },
    props: {
      guid:{
        type:String,
        default:""
      },
      code: {
        type: String,
        default: 'oaList'
      }
    },
    methods: {
      //审核进度点击事件
      CheckDetail(){
        let that = this
        //使弹窗可见
        this.dialogVisible  = true
        //参数从props中获取
        let params = {
          systemdataid: this.guid
        }
        that.$utils.HttpPost(that.searchUrl,params,function(data){
          let dataList = data.Data
          // 处理数据的数组
          let copyList = []
          dataList.forEach(function(item){
            //如果审核意见有值，才会推入数组
            if(item.bq015003){
              copyList.push({
                CheckUser:item.bq010003,
                CheckInfo:item.bq015003,
              })
            }

          })
          that.tableData = that.$utils.clone(copyList)
          console.log(that.tableData);
        },null,null,null)
      }
    },
  }
</script>

<style scoped>
 .cell-button-box {
    flex:1
  }
  
  .cell-button-box .footer-button{
    width: 100%;
  }
 
</style>
